import { render, staticRenderFns } from "./welcome-setup-team.vue?vue&type=template&id=d7085686&scoped=true&"
import script from "./welcome-setup-team.vue?vue&type=script&lang=js&"
export * from "./welcome-setup-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7085686",
  null
  
)

export default component.exports